import React from 'react';
import { TriangleAlertIcon } from 'lucide-react';
export function ScarcityBar() {
  return <div className="w-full bg-alert px-4 py-2.5 text-center" data-id="element-130" data-mp="2yw2tnzlar6xo">
      
    </div>;
}